import React from 'react';
import { AssetAllocationDTO } from '../../../../../../../../api/useAccountsOptionsQuery';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../../../CommonComponents/OPL/Text/Text';
import { AssetAllocationStackChart } from '../../../AssetAllocationStackChart/AssetAllocationStackChart';
import { AssetAllocationTable } from '../../../AssetAllocationTable/AssetAllocationTable';
import { AssetsAllocationTableTotal } from '../../../AssetsAllocationTableTotal/AssetsAllocationTableTotal';

interface Props {
  chartValues: AssetAllocationDTO[];
  assetAllocationTaxStatus: number | null;
  readOnly?: boolean;
  shouldUnsyncAssetAllocationOnChange?: boolean;
}

export const AllocationContent = ({
  chartValues,
  assetAllocationTaxStatus,
  readOnly,
  shouldUnsyncAssetAllocationOnChange,
}: Props) => {
  return (
    <>
      <Box py="16">
        <Text fontWeight={600}>Monte Carlo Simulation Asset Allocation</Text>

        <Box pt="16">
          <AssetAllocationStackChart chartValues={chartValues} />
        </Box>
      </Box>

      <AssetAllocationTable
        chartValues={chartValues}
        assetAllocationTaxStatus={assetAllocationTaxStatus}
        readOnly={readOnly}
        shouldUnsyncAssetAllocationOnChange={shouldUnsyncAssetAllocationOnChange}
      />

      <AssetsAllocationTableTotal chartValues={chartValues} />
    </>
  );
};
